import { render, staticRenderFns } from "./PayIncorrect.vue?vue&type=template&id=2bc1c6ed&scoped=true&"
import script from "./PayIncorrect.vue?vue&type=script&lang=js&"
export * from "./PayIncorrect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc1c6ed",
  null
  
)

export default component.exports